import { HttpClient } from "../../../commonApis/httpClient";
import * as ApiEvents from './apiEvents'
import _ from "lodash";

export const AESMockServicecall =(shipmentId,responseCode,processIndicator,aesStatus,circuit)=>{
  const data = {
    eventMessage: {
      shipmentId,
      responseCode,
      processIndicator,
      aesStatus,
      circuit
          },
    eventType:ApiEvents.MOCK_AES
  }
  return HttpClient.custom({
    data
})
}

export const PDCAccept = (shipmentId, responseCode, operationCode, circuit, mrn, formType) => {
    const data = {
        eventMessage: {
          shipmentId,
          responseCode,
          operationCode,
          circuit,
          mrn
        },
        eventType: formType === "PDC" ? ApiEvents.MOCK_PDC : ApiEvents.MOCK_FULL_SAD,
    }
    return HttpClient.custom({
        data
    })
  }

export const PDCAmendAccept = (shipmentId, responseCode, operationCode, circuit, mrn, requireCertificate) => {
    const data = {
        eventMessage: {
          shipmentId,
          responseCode,
          operationCode,
          requireCertificate,
          circuit,
          mrn
        },
        eventType: ApiEvents.MOCK_PDC_AMEND,
    }
    return HttpClient.custom({
        data
    })
  }

export const mockCancel = (shipmentId, responseCode, errorCode, errorDescription, errorItemNumber, errorItemOrderNumber, errorLabel, errorValue, formType) => {
    const data = {
        eventMessage: {
          shipmentId,
          responseCode,
          errorCode,
          errorDescription,
          errorItemNumber,
          errorItemOrderNumber,
          errorLabel,
          errorValue
        },
        eventType: formType === "PDC" ? ApiEvents.MOCK_PDC : formType === "PdcAmend" ?  ApiEvents.MOCK_PDC_AMEND : formType === "FullSad" ? 
        ApiEvents.MOCK_FULL_SAD : formType === "Box40" ? ApiEvents.MOCK_BOX_40 : formType === "Box44" ? ApiEvents.MOCK_BOX_44 : formType === "Cancel" ? ApiEvents.MOCK_CANCEL : formType
    }
    return HttpClient.custom({
        data
    })
  }

  export const BOX44Accept = (shipmentId, responseCode, dispatchStatus, accountingStatus, circuit, mrn, releaseIndicator) => {
    const data = {
        eventMessage: {
          shipmentId,
          responseCode,
          circuit,
          dispatchStatus,
          accountingStatus,
          mrn,
          releaseIndicator
        },
        eventType: ApiEvents.MOCK_BOX_44,
    }
    return HttpClient.custom({
        data
    })
  }
  export const BOX40Accept = (shipmentId, responseCode, requireCertificate, circuit, mrn) => {
    const data = {
        eventMessage: {
          shipmentId,
          responseCode,
          circuit,
          requireCertificate,
          mrn
        },
        eventType: ApiEvents.MOCK_BOX_40,
    }
    return HttpClient.custom({
        data
    })
  }

  export const cancelAccepted = (shipmentId, mrn) => {
    const data = {
        eventMessage: {
          shipmentId,
          mrn
        },
        eventType: ApiEvents.MOCK_CANCEL,
    }
    return HttpClient.custom({
        data
    })
  }

  export const exportMock = (shipmentId, processIndicator, mrn, acceptanceDate, exportData) => {
    const data = {
        eventMessage: {
          processIndicator,
          shipmentId,
          mrn,
          acceptanceDate,
          ...exportData
        },
        eventType: ApiEvents.MOCK_EXPORT_TYPE,
    }
    if(processIndicator === "2" || processIndicator === "3"){
      delete data.eventMessage.acceptanceDate;
    }
    return HttpClient.custom({
        data
    })
  }